export default () => {

  const s = {};
  const init = () => {
    console.log('init sort accordion')
    s.root = document.getElementById('athlete-sort');
    if (!s.root) {
      return;
    }

    buildAccordion();
  }

  const buildAccordion = () => {
    s.sortItems = s.root.querySelectorAll('.js-accordion');
    s.sortItems.forEach(sortItem => {
      initAccordion(sortItem);
    });
  }
  const initAccordion = (accordion) => {
    const accordionTarget = accordion.querySelector('.at-sort__target');
    const accordionBody = accordion.querySelector('.at-sort__select');

    accordionTarget.addEventListener('click', (e) => {
      e.preventDefault();
      bindClickAccordionAction(accordion, accordionBody);
      accordionTarget.classList.toggle('is-selected');
    });

  }
  const bindClickAccordionAction = (accordion, body) => {
    const isOpen = accordion.classList.contains('is-open');
    if (isOpen) {
      accordionBodyCloseAction(body);
    } else {
      accordionBodyOpenAction(body);
    }
    accordion.classList.toggle('is-open');
  }
  const accordionBodyOpenAction = (body) => {
    const entity = body.firstElementChild;
    const entityHeight = entity.offsetHeight;
    body.style.height = `${entityHeight}px`;
  }
  const accordionBodyCloseAction = (body) => {
    body.style.height = '0px';
  }

  init ();

  return {}
}
